import Vue from "vue";

import EightBit from "./8BitatBat.vue";

export function load() {
    const selector = "eight-bit-at-bat";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(EightBit, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
